import { decodeJwt as joseDecodeJwt } from 'jose'
import type { UserJwtPayload } from './types'

export default function decodeJwt<T = UserJwtPayload>(jwt: string): T {
  const decoded = joseDecodeJwt(jwt)
  return decoded as unknown as T // ugly cast since we can't predict the shape of the payload // FIXME: Zodify this?
}
